<div class="container">
  <app-general-header title="Implementation Plan" />
  <a routerLink="/plans" class="text-decoration-none text-body-secondary"
    >&lt; Back to Plans</a
  >
  <ng-container *ngIf="!forbidden; else deniedMessage">
    <div class="row mt-2 mb-4">
      <div
        *ngIf="planDashboardInfo?.title; else noTitle"
        class="col text-center">
        <div class="d-flex justify-content-center align-items-center">
          <h1 class="fw-600">
            {{ planDashboardInfo.title }}
          </h1>
        </div>
        <div>
          {{ planDashboardInfo.start_date }} -
          {{ planDashboardInfo.end_date }}
        </div>
      </div>
      <ng-template #noTitle>
        <div style="height: 7.5rem"></div>
      </ng-template>
    </div>

    <div class="row" *ngIf="planDetails && planDetails.id; else loading">
      <div class="col-12 col-xl-8">
        <div class="card bg-none border-0">
          <ng-container *ngIf="planDashboardInfo?.title">
            <app-plans-subnav [plan]="planDetails" />
          </ng-container>
          <app-phase-plan-status-card [dashboardInfo]="planDashboardInfo" />
        </div>
        <app-phase-progress-card [dashboardInfo]="planDashboardInfo" />
      </div>
      <div class="custom-margin-top col-12 col-xl-4 mt-4">
        <app-phase-risk-delays-card
          *ngIf="
            planDashboardInfo &&
            planDashboardInfo.items_that_need_attention.length
          "
          [items]="planDashboardInfo.items_that_need_attention" />
        <app-card-activity-feed
          *ngIf="planDashboardInfo"
          [planEditor]="planEditor"
          [activityStreamToken]="planDashboardInfo.getstream_token"
          [planId]="planDashboardInfo.id"
          [districtTimezone]="user?.district?.timezone" />
      </div>
    </div>
  </ng-container>
  <ng-template #deniedMessage>
    <div class="mt-5">
      <app-permission-denied />
    </div>
  </ng-template>
  <ng-template #loading>
    <div
      class="w-100 position-relative mt-3"
      style="background-color: #fff; height: 600px">
      <app-loader></app-loader>
    </div>
  </ng-template>
</div>
